import {FC, MouseEventHandler, ReactNode, useEffect, useState} from "react";
import {Button, Form, Modal} from "react-bootstrap";
import {FormText} from "./index";
import {ButtonProps} from "react-bootstrap/Button";

// ボタンタイプ
type ConfirmModalButtonProps = Omit<ButtonProps, 'onClick' | 'disabled' | 'children'>;

// モーダル
export const ConfirmModal: FC<{
  children: ReactNode,
  size?: 'sm' | 'lg' | 'xl' | undefined,
  show: boolean,
  keyword?: string,
  confirmButtonProps?: ConfirmModalButtonProps,
  confirmLabel: string,
  onConfirm: MouseEventHandler<HTMLButtonElement>,
  onCancel: () => void
}> = ({show, size, children, confirmButtonProps, confirmLabel, keyword, onConfirm, onCancel}) => {

  // キーワード入力
  const [inputKeyword, setInputKeyword] = useState<string>('');

  // キーワードリセット
  useEffect(() => {
    setInputKeyword('');
  }, [show]);

  return (
      <Modal show={show}
             backdropClassName={'system-modal'}
             size={size}>

        <Modal.Body className={`m-body`}>
          <div className={`m-2 my-3 my-lg-5 fs-5`}>
            {children}
          </div>

          {/* キーワード */}
          {keyword && (
              <div className={'m-3'}>
                <FormText placeholder={keyword}
                          value={inputKeyword}
                          onChange={(event) => setInputKeyword(event.currentTarget.value)}/>
                <Form.Text className="text-muted">
                  * 実行するには「{keyword}」と入力してください
                </Form.Text>
              </div>
          )}
        </Modal.Body>

        <Modal.Footer className={'justify-content-center'}>
          <Button variant="secondary"
                  style={{minWidth: '10em'}}
                  size={'sm'}
                  onClick={onCancel}>
            キャンセル
          </Button>

          <Button {...confirmButtonProps}
                  style={{minWidth: '10em'}}
                  size={'sm'}
                  onClick={onConfirm}
                  disabled={!!keyword && keyword !== inputKeyword}>
            {confirmLabel}
          </Button>
        </Modal.Footer>
      </Modal>
  )
}
